import classNames from 'classnames';
import React from 'react';
import { ActionButton, ActionCardSC, ActionLink, clsPrefix } from './action-card.styled';
import { TActionCardState, TActionCardVariant } from './action-card.types';

interface ActionCardProps
  extends Omit<
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    'ref'
  > {
  left?: React.ReactNode;
  children?: React.ReactNode;
  right?: React.ReactNode;

  variant?: TActionCardVariant;
  /**
   * Not implemented
   */
  state?: TActionCardState;
}

const ActionCard = (props: ActionCardProps): JSX.Element => {
  const { className, style, left, right, children, variant = 'on-background', state } = props;

  return (
    <ActionCardSC
      className={classNames(clsPrefix, className, `${clsPrefix}-${variant}`, {
        [`${clsPrefix}-${state}`]: !!state,
        [`${clsPrefix}-has-left`]: !!left,
        [`${clsPrefix}-has-right`]: !!right,
      })}
      style={style}
    >
      {left}
      <div className={`${clsPrefix}-content`}>{children}</div>
      {right}
    </ActionCardSC>
  );
};

ActionCard.Button = ActionButton;
ActionCard.Link = ActionLink;

export default ActionCard;
